export function formatPhoneForLink(input) {
  if (!input) {
    return '';
  }
  // Remove any non-digit characters
  const cleanNumber = input?.replace(/\D/g, '');

  // Check if the number starts with '8' and replace it with '+7'
  const normalizedNumber = cleanNumber.startsWith('8')
    ? '+7' + cleanNumber.slice(1)
    : cleanNumber;

  // If the number does not start with '+7', add it
  const finalNumber = normalizedNumber.startsWith('+7')
    ? normalizedNumber
    : '+7' + normalizedNumber;

  return finalNumber;
}
